import UserTopNavbar    from "../../components/user-components/navbar/UserTopNavbar";
import UserBottomNavbar from "../../components/user-components/navbar/UserBottomNavbar";
import BackToTop        from "../../components/user-components/BackToTop";
import FloatingSurveyBubble from "../../components/user-components/survey/FloatingSurveyBubble";

function UserLayout({ children }) {
  return (
    <div>
      <UserTopNavbar />
      <UserBottomNavbar />

      {/* Push content below both fixed bars: 52px navbar + ~48px gold bar */}
      <div>
        {children}
      </div>

      {/* Floating back-to-top button */}
      <BackToTop />
      
      {/* Floating smart survey bubble */}
      <FloatingSurveyBubble />
    </div>
  );
}

export default UserLayout;